
const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center py-32 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/f83d156e11a2426b048728ea2430d100.jpg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/80 to-slate-900/70"></div>
      </div>

      {/* Animated particles */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-cyan-400 rounded-full animate-ping"></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-teal-400 rounded-full animate-pulse"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center max-w-5xl">
        <div className="inline-block mb-6">
          <span className="px-4 py-2 bg-blue-600/20 text-blue-300 rounded-full text-sm font-medium border border-blue-400/30">
            Our Expertise
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl font-light text-white mb-6 leading-tight">
          Our <strong className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Services</strong>
        </h1>
        <p className="text-xl md:text-2xl text-blue-200 mb-8 font-light">
          Innovative Solutions in Energy, Intelligence & Manufacturing
        </p>
        <p className="text-lg text-white/80 leading-relaxed max-w-3xl mx-auto">
          From oil & gas exploration technology to industrial intelligent monitoring, software development, and OEM manufacturing, 
          we deliver comprehensive solutions that drive innovation and operational excellence across critical industries.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
